@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.root {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 20px;
  flex-shrink: 0;
  height: 100%;
  width: 100%;
  overflow-x: auto;

  @include for-desktop-only {
    padding-bottom: 20px;
  }
}
